var React = require('react');

function FacebookIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18 17.007a.993.993 0 01-.993.993H12.42v-6.97h2.34l.35-2.717h-2.69V6.579c0-.787.218-1.323 1.346-1.323h1.439v-2.43a19.143 19.143 0 00-2.096-.108c-2.074 0-3.494 1.266-3.494 3.591v2.004H7.269v2.716h2.346V18H.993A.993.993 0 010 17.007V.993C0 .445.445 0 .993 0h16.014c.548 0 .993.445.993.993v16.014","fill":"#3E579B","fillRule":"evenodd"}));
}

FacebookIconInline.defaultProps = {"width":"18","height":"18"};

module.exports = FacebookIconInline;

FacebookIconInline.default = FacebookIconInline;
